/* Theme tokens + helpers. The form reads CSS custom properties (see brand.css);
   accent/font selections are applied as inline vars on the form wrapper, which
   override the :root defaults. The default accent and faces come from
   brand.config.js `theme` (see src/themeBrand.js); the named presets below
   remain available as mount options. */
import { THEME } from "./themeBrand.js";

export const ACCENTS = {
  brand: { c: THEME.accent, c6: THEME.accentDark, c7: THEME.accentDarker, t: THEME.accentTint, t2: THEME.accentTint2 },
  "#E8476A": { c: "#E8476A", c6: "#D2375A", c7: "#B62B4C", t: "#FDEAEF", t2: "#FFF4F7" },
  "#5B6CF0": { c: "#5B6CF0", c6: "#4453D6", c7: "#3A47BC", t: "#ECEEFD", t2: "#F5F6FE" },
  "#1F8A5B": { c: "#1F8A5B", c6: "#187749", c7: "#13603C", t: "#E6F4EC", t2: "#F2F9F5" },
};

export const FONTS = {
  brand: { d: `'${THEME.fontDisplay}'`, b: `'${THEME.fontBody}'`, families: THEME.googleFonts || [] },
  "Plus Jakarta Sans / Inter": { d: "'Plus Jakarta Sans'", b: "'Inter'", families: ["Plus+Jakarta+Sans:wght@400;500;600;700;800", "Inter:wght@400;500;600;700"] },
  "Sora / Inter": { d: "'Sora'", b: "'Inter'", families: ["Sora:wght@400;500;600;700;800", "Inter:wght@400;500;600;700"] },
  "Manrope": { d: "'Manrope'", b: "'Manrope'", families: ["Manrope:wght@400;500;600;700;800"] },
};

/* Build the inline CSS-variable object for the wrapper element. */
export function themeVars(accentKey, fontKey) {
  const acc = ACCENTS[accentKey] || ACCENTS.brand;
  const fnt = FONTS[fontKey] || FONTS.brand;
  return {
    "--coral": acc.c, "--coral-600": acc.c6, "--coral-700": acc.c7, "--coral-tint": acc.t, "--coral-tint-2": acc.t2,
    "--sh-coral": `0 6px 16px -4px ${acc.c}80`,
    "--font-display": `${fnt.d}, -apple-system, system-ui, sans-serif`,
    "--font-body": `${fnt.b}, -apple-system, system-ui, sans-serif`,
  };
}

/* Inject the Google Fonts <link> for the selected font once (idempotent).
   Hosts that already self-host fonts can disable this via the `fonts` option. */
export function ensureFonts(fontKey) {
  if (typeof document === "undefined") return;
  const fnt = FONTS[fontKey] || FONTS.brand;
  const id = "pf-fonts-" + (fontKey || "default").replace(/[^a-z0-9]/gi, "-").toLowerCase();
  if (document.getElementById(id)) return;
  const href = "https://fonts.googleapis.com/css2?" + fnt.families.map((f) => "family=" + f).join("&") + "&display=swap";
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}
